export const NO_ANSWER = 'NO_ANSWER'
export const CONTACTED = 'CONTACTED'
export const WRONG_NUMBER = 'WRONG_NUMBER'
export const DECLINED = 'DECLINED'
export const LEFT_MESSAGE = 'LEFT_MESSAGE'
export const MISSED = 'MISSED'
export const CREATED = 'CREATED'
export const NOT_COMPLETED = 'NOT_COMPLETED'

export interface CallStatusOption {
  key: 'NO_ANSWER' | 'CONTACTED' | 'WRONG_NUMBER' | 'DECLINED' | 'LEFT_MESSAGE' | 'MISSED' | 'CREATED' | 'NOT_COMPLETED'
  name: string
  colorClass: string
  colorVarName: string
}

export const callStatusesMap: Record<string, CallStatusOption> = {
  [NO_ANSWER]: {
    key: NO_ANSWER,
    name: 'No Answer',
    colorClass: 'error',
    colorVarName: '--text-red-600',
  },
  [CONTACTED]: {
    key: CONTACTED,
    name: 'Contacted',
    colorClass: 'success',
    colorVarName: '--text-success-700',
  },
  [WRONG_NUMBER]: {
    key: WRONG_NUMBER,
    name: 'Wrong Number',
    colorClass: 'primary',
    colorVarName: '--text-primary-default',
  },
  [DECLINED]: {
    key: DECLINED,
    name: 'Declined',
    colorClass: 'error',
    colorVarName: '--text-red-600',
  },
  [LEFT_MESSAGE]: {
    key: LEFT_MESSAGE,
    name: 'Left Message',
    colorClass: 'success',
    colorVarName: '--text-success-700',
  },
  [MISSED]: {
    key: MISSED,
    name: 'Missed',
    colorClass: 'error',
    colorVarName: '--text-red-600',
  },
  [CREATED]: {
    key: CREATED,
    name: 'Created',
    colorClass: 'gray',
    colorVarName: '--text-gray-500',
  },
  [NOT_COMPLETED]: {
    key: NOT_COMPLETED,
    name: 'Not Completed',
    colorClass: 'error',
    colorVarName: '--text-red-600',
  },
}

export const options = Object.values(callStatusesMap) as CallStatusOption[]
